import { createAction } from '../../../../store.model';
import { ActionType } from '../event-centre-dialog.action';
import { ViewItem } from '../model/view-item.model';

export interface ReceiveItems {
    items: ViewItem[];
}

export const receiveItems = createAction<ActionType, ReceiveItems>(
    ActionType.NOTI__EC__RECEIVE_ITEMS,
);
